import { put, takeLatest } from "redux-saga/effects";
import { requestLoiList 
    ,requestCreateLoi, requestUpdateLoi
} from "services/manage-property/property-loi/LOIDetails";

import {
  fetchLoiListRequest,
  fetchLoiListSuccess,
  fetchLoiListFailure,

  createLoiRequest,
  createLoiSuccess,
  createLoiFailure,
  updateLoiRequest,
  updateLoiSuccess,
  updateLoiFailure
} from "../../../../actions/manage-property/property-loi/LOIDetails/loi-details";

import {
  FETCH_LOI_LIST_REQUEST,
  FETCH_LOI_LIST_SUCCESS,
  FETCH_LOI_LIST_FAILURE,
  CREATE_LOI_REQUEST,
  UPDATE_LOI_REQUEST
} from "../../../../actions/manage-property/property-loi/LOIDetails/types";

export function* watchLoiListSaga() {
  yield takeLatest(FETCH_LOI_LIST_REQUEST, fetchLoiList);
  yield takeLatest(CREATE_LOI_REQUEST, createLoi);
  yield takeLatest(UPDATE_LOI_REQUEST, updateLoi);
}

function* fetchLoiList({ payload }) {
  try {
    /**
     * @type {FetchBrokerFirmsResponse}
     */
    const response = yield requestLoiList(payload);
    yield put(fetchLoiListSuccess(response));
  } catch (error) {
    yield put(fetchLoiListFailure("Failed to get list of LOI list"));
  }
}



/**
 *
 * @param {PARAMS} param0
 */
 function* createLoi({ payload }) {
  try {
      const response = yield requestCreateLoi(payload);
      yield put(createLoiSuccess(response.data));
  } catch (error) {
      yield put(
        createLoiFailure('Failed to create LOI')
      );
  }
}

/**
*
* @typedef {Object} BrokerFirmUpdatePayload
* @property {BrokerFirm} payload
*
* @param {BrokerFirmUpdatePayload} param0
*/
function* updateLoi({ payload }) {
  try {
     const response =  yield requestUpdateLoi(payload);
      yield put(updateLoiSuccess(response.data));
  } catch (error) {
      yield put(
          updateLoiFailure('Failed to update LOI')
      );
  }
}